module.exports = __webpack_public_path__ + "img/Classification.1db239e9.jpg";